import React, { useState } from "react";
import Banner from "@hig/banner";
import Button from "@hig/button";

const bannerStyles = (styles) => ({
    ...styles,
    banner: {
        ...styles.banner,
        maxHeight: "50px",
    },
    content: {
        ...styles.content,
        margin: "0 0 0 16px",
        alignItems: "baseline",
    },
});

const buttonStyles = {
    margin: "2px 0 0 0",
    maxHeight: "34px",
};
// TODO: DEVX-8354 GracePeriod logic, do not need this component
const LowBalanceBanner = () => {
    const [showBanner, setShowBanner] = useState(true);
    const onDismissHandler = () => {
        setShowBanner(false);
    };

    return (
        <Banner
            type="warning"
            onDismiss={onDismissHandler}
            isVisible={showBanner}
            stylesheet={bannerStyles}
            actions={() => (
                <Banner.Interactions>
                    <Banner.Action>
                        <Button
                            data-test-id="low-bal-banner-buy-tokens-button"
                            data-external-target="low-bal-banner-buy-tokens-button"
                            size="standard"
                            title={"Buy tokens"}
                            type="secondary"
                            width="shrink"
                            link="//aps.autodesk.com/pricing"
                            target="_blank"
                            style={buttonStyles}
                        />
                    </Banner.Action>
                </Banner.Interactions>
            )}
        >
          <strong> Your token balance is running low. </strong> To avoid service disruption, please purchase more tokens.
        </Banner>
    );
};

export default LowBalanceBanner;
